var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.log, "empty-label": "暂无日志信息", stripe: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "time", label: "Time", width: "140" }
          }),
          _c("el-table-column", {
            attrs: { prop: "message", label: "Message" }
          }),
          _c("el-table-column", {
            attrs: { label: "Url", align: "center", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(" " + _vm._s(_vm._.get(scope.row, "meta.url")) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "Tag", align: "center", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._.get(
                      scope.row,
                      "meta.instance.$vnode.componentOptions.tag"
                    )
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v(
                            " <" +
                              _vm._s(
                                _vm._.get(
                                  scope.row,
                                  "meta.instance.$vnode.componentOptions.tag"
                                )
                              ) +
                              "> "
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              label: "More",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("d2-button", {
                      attrs: { type: "primary", fa: "eye" },
                      on: {
                        click: function($event) {
                          return _vm.handleShowMore(scope.row)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("d2-button", {
            attrs: {
              type: "primary",
              fa: "cloud-upload",
              loading: _vm.uploading,
              label: "Upload " + _vm.log.length + " log data"
            },
            on: { click: _vm.handleUpload }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }